module.exports = __webpack_public_path__ + "img/CIO210_1-1.af023f1c.png";